import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
} from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { NextaBaseList } from "../shared/nexta-crud/nexta-base-list";
import { NotificationService } from "../shared/notification.service";
import { UserService } from "./crud.service";
import { User } from "./user";

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	templateUrl: "./user-list.component.html",
	standalone: false,
})
export class UserListComponent extends NextaBaseList<User> {
	constructor(
		router: Router,
		userService: UserService,
		notificationService: NotificationService,
		route: ActivatedRoute,
		cdr: ChangeDetectorRef,
	) {
		super(
			"/benutzer",
			router,
			userService,
			notificationService,
			route,
			"users",
			cdr,
		);
	}
}
